// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"abd996b4","688":"c27869b5"}[chunkId] + ".chunk.js";
};